/** Athlete website streams. This app must never report into these. */
const ATHLETE_PWA_MEASUREMENT_IDS = new Set(["G-Y8DNP0FGD8", "G-G31Q27H79T"]);

export interface AnalyticsStream {
  appId: string;
  measurementId: string;
}

/** Empty, missing, or athlete-site ids mean analytics stays off. */
export function resolveAnalyticsStream(
  authAppId: string,
  appId: string | undefined,
  measurementId: string | undefined,
): AnalyticsStream | null {
  const resolvedAppId = (appId || "").trim();
  const resolvedMeasurementId = (measurementId || "").trim();
  if (!resolvedAppId || !resolvedMeasurementId) return null;
  if (ATHLETE_PWA_MEASUREMENT_IDS.has(resolvedMeasurementId)) return null;
  if (resolvedAppId === authAppId) return null;
  return { appId: resolvedAppId, measurementId: resolvedMeasurementId };
}
